import React from 'react';
import { useTranslation } from 'react-i18next';
import {useDispatch} from 'react-redux';
import {WbEventHandlerMixins} from '../../../utils/common';
import * as CardAction from './../../actions/card.actions';

import { v4 as uuidv4 } from 'uuid';
import {
  generateSASAnduploadToTempLocation,
  WoboFileUploadService,
  pollFileStatus,
} from '../../../services/fileupload.service'
import GoalServices from '../../../services/goal.services'

const services = new GoalServices()

const FreeTextForm = (props: any) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { columnId, boardDetails, fusDetail } = props;
    const wrapperClass = `wsboard-aiform-wrapper board-column-aiform-${boardDetails.boardType}-${columnId}`;
    const [submitData, setSubmitData] = React.useState(false);
    const freetextAdd = React.createRef<HTMLDivElement>();
    let myDropzone:any;

    React.useEffect(() => {
        ($(".wsboard-aiform-wrapper") as any).hide();
        ($(".wsBoardAiColDraggableWrapper")as any).removeClass(
          "WsBoardAddNewColumnClass"
        );
        ($(`.board-column-aiform-${boardDetails.boardType}-${props.columnId}`)as any).show();
        ($(`.board-column-aiform-${boardDetails.boardType}-${props.columnId}`)as any)
          .next(".wsBoardAiColDraggableWrapper")
          .addClass("WsBoardAddNewColumnClass");
      ($(`.board-column-aiform-${boardDetails.boardType}-${props.columnId} .wsBoardAddAi`) as any).trigger(
        "focus"
      );
        const eleId = `freetextAdd_${props.columnId}`;
        if (!($(`#${eleId}`) as any).length) return;
        initializeDropzone({
          s3Data: boardDetails.s3Data,
          updateFreeText: updateFreeText,
          elementId: eleId,
          upload_max_size: boardDetails.upload_max_size,
          upload_max_size_configured: boardDetails.upload_max_size_configured
        });
        window.addEventListener("click", onSubmitFreeText, true);
        return () => { 
            window.removeEventListener("click", onSubmitFreeText, true); 
        }
    }, []);

    const updateFreeText = (desc:any, myObjectS3Data:any, file: any) => {
            let empDesc;
      if (desc != "" && desc != null) {
        desc = desc.trim();
        empDesc = desc.replace("<br>", "");
      }
      if (myObjectS3Data && !(fusDetail && fusDetail.isFUSEnabled)) {
        dispatch(CardAction.BoardUpdateS3Data(myObjectS3Data));
      }
      if (desc != null && desc.length > 0 && empDesc.length > 0) {
        const params:any = { description: desc, columnId };
        
                // insert temp arr in JSON
        const randNum = Math.floor(Math.random() * 10000000) + 1;
        const tempFtId = `newFt_${randNum}`;
        const tempFreeText:any = WbEventHandlerMixins.getTempFt(desc, tempFtId);
        tempFreeText.board_column = columnId;
        dispatch(CardAction.BoardFreeTextAdd(tempFreeText));
        
        if (($ as any).ajaxSetup().data.YII_CSRF_TOKEN) {
          params.YII_CSRF_TOKEN = ($ as any).ajaxSetup().data.YII_CSRF_TOKEN;
        }
        
        if (fusDetail.isFUSEnabled && file) {
          params.fus_type = 1;
          params.fus_status = 2;
          params.prefix = `FUS_${file.requestId}`;
          params.fileName = file.name;
          params.fileSize = file.size;
          params.s3DirectUpload = 2;
          params.file_signature = `FUS_${file.requestId}`;
        }
        
        $.post(
          `${wbConfig.baseUrl}/board/savefreeText`,
          params,
          (response) => {
              const freeTextData = response.data;
              if (fusDetail.isFUSEnabled && file) {
                let url = `${wbConfig.baseDomainUrl}`+ '/vnext/fus/api/v1/download/' + params.file_signature;
                const imgLoad = tempImgLocation();
                let desc = freeTextData.description.replace(`src="${url}"`, `src="${imgLoad}"`);
                freeTextData.description = desc;
                dispatch(CardAction.BoardFreeTextUpdate(tempFtId, freeTextData));
                callProcessFileWithFus(file, response, freeTextData.description)
              } else {
                dispatch(CardAction.BoardFreeTextUpdate(tempFtId, freeTextData));
              }
              setSubmitData(false);
              removeLoaderWidget();
          }
        );
        props.hideAIForm();
        try {
          removeLoaderWidget();
          myDropzone.destroy();
        } catch (err) {}
      }
    }

    const tempImgLocation = () => {
      return  `${wbConfig.baseDomainUrl}`+ '/images/loadimages/image_scan_2.gif';
    }

    const callProcessFileWithFus = (file, response, description) => {
      var userId = fusDetail.userId
      var orgId = fusDetail.orgId
      var fileDetails = {
        source_fileName: file.source_fileName,
        file_mimetype: file.type || 'image/jpeg',
        file_size: file.size,
        request_id: file.requestId,
        signature: `FUS_${file.requestId}`,
        isCropped: false,
        isPublic: false,
        appInID: fusDetail.appinID,
        byok_tenant_id: '',
        file_originalname: file.name,
        webhook_details: {
          host: `${wbConfig.baseDomainUrl}/fus/fusCallback?type=4&fid=${response.data.id}&cId=${columnId}`,
          path: '',
        },
        orgId: orgId,
        userId: userId,
        target_folder: uuidv4(),
        freeTextId: response.data.id,
      }
      WoboFileUploadService.processFile(fileDetails).then(() => {
          updateFile(fileDetails.signature, 2000, fileDetails.freeTextId )
      })
      .catch((err) => {
        dispatch(
          CardAction.BoardDelteItemInColumn({
            id: response.id,
            colId: columnId,
          })
        )
        const url = `${wbConfig.baseUrl}/board/deleteFreeText`
        const params = { id: response.id }
        $.post(url, params)
        console.log(err)
      })
    }
  
    const updateFile = (signature, delayMs, freeTextId) => {
      const clearTimer = setInterval(async () => {
        services
          .getFileStatus({ signature, freeTextId })
          .then((response) => {
            const jsonData = response?.data
            if (jsonData) {
              if (
                jsonData?.resp?.fus_type == 1 &&
                jsonData?.resp?.fus_status == 1 
              ) {
                clearInterval(clearTimer)
                const url = `${wbConfig.baseDomainUrl}`+ '/vnext/fus/api/v1/download/' + signature;
                WoboFileUploadService.download(url).then(async (res)=>{
                  const blob = await res.blob();
                  const blobUrl = URL.createObjectURL(new Blob([blob]));
                  jsonData?.resp?.description.replace(`src="${url}"`, `src="${blobUrl}"`);
                  dispatch(CardAction.BoardFreeTextUpdateImg(jsonData?.resp?.id, jsonData?.resp));
                })
              }
            }
          })
          .catch((err) => {})
      }, delayMs)
    }
    
    const onSubmitFreeText = (e:any) => {
              let description = $(freetextAdd.current).length
        ? $(freetextAdd.current)
            .html()
            .trim()
        : "";
      if (description.includes('dz-preview dz-image-preview dz-processing')) {
        description = '';
      }
      const freeTxtContainer = $(".wsBoardAddAi");
      if (
        !submitData &&
        description.length > 0 &&
        (!$(freeTxtContainer).is(e.target) &&
          $(freeTxtContainer).has(e.target).length === 0)
      ) {
        setSubmitData(true);
        updateFreeText(description, null, null);
      } else {
          if (!$(freeTxtContainer).is(e.target) &&
              $(freeTxtContainer).has(e.target).length === 0) {
              props.hideAIForm()  
          }
      }
    }

    const initializeDropzone = (props:any) => {
        const ftS3Data = props.s3Data;
        const _this = this;
        let urlVal = `https://${ftS3Data.file_bucket}.s3.amazonaws.com/`;
        const getS3Url = `${wbConfig.baseUrl}/workboard/getS3Data`;
        const eleId = `#${props.elementId}`;
        const { upload_max_size } = props;
        const { upload_max_size_configured } = props;

        if (fusDetail.isFUSEnabled) {
          urlVal = `${wbConfig.baseDomainUrl}/vnext/fus/api/v1/sastoken`;
        }
        
        myDropzone = new Dropzone(eleId, {
          url: urlVal,
          autoProcessQueue: false,
          autoDiscover: false,
          uploadMultiple: false,
          acceptedFiles:
            "image/jpeg, image/png, image/gif, image/jpg, image/bmp, image/tiff",
          thumbnailMethod: "crop",
          parallelUploads: 100,
          clickable: false,
          maxFilesize: upload_max_size_configured,
          init() {
            const myDropzone = this;
            myDropzone.on("addedfile", function(file:any) {
              try {
                setTimeout(() => {
                  // showLoaderWidget($("#content"));
                  myDropzone.processQueue();
                }, 500);
              } catch (err) {
                console.log("Unable to upload file");
              }
            });
            myDropzone.on("sending", (file:any, xhr:any, formData:any) => {
              showLoaderWidget($("#content"));
              if (!fusDetail.isFUSEnabled) {
                const fileName = file.name;
                const fileType = file.type;
                const key = replaceS3Key(ftS3Data.key, fileName);
                formData.append("key", key);
                // check the acl in the data
                if (ftS3Data.acl == "public-read") {
                  formData.append("acl", "public-read");
                  formData.append("AWSAccessKeyId", ftS3Data.keyId);
                  formData.append("policy", ftS3Data.policy);
                  formData.append("signature", ftS3Data.signature);
                  formData.append("success_action_status", 201);
                  formData.append("Filename", replaceSpcicalCharacter(fileName));
                  formData.append("Content-type", fileType);
                } else {
                  formData.append("policy", ftS3Data.policy);
                  formData.append("success_action_status", 201);
                  formData.append("Filename", replaceSpcicalCharacter(file.name));
                  formData.append("acl", "authenticated-read");
                  if (
                    typeof ftS3Data.encrypt_type !== "undefined" &&
                    ftS3Data.encrypt_type == "aws:kms"
                  ) {
                    formData.append("x-amz-algorithm", ftS3Data.algo);
                    formData.append("x-amz-credential", ftS3Data.credential);
                    formData.append("x-amz-date", ftS3Data.short_date);
                    formData.append("x-amz-signature", ftS3Data.signature);
                  } else if (
                    typeof ftS3Data.encrypt_type !== "undefined" &&
                    ftS3Data.encrypt_type == "aws:ssc"
                  ) {
                    const enKeys = JSON.parse(ftS3Data.encrypt_keys);
                    formData.append("AWSAccessKeyId", ftS3Data.keyId);
                    formData.append("signature", ftS3Data.signature);
                    formData.append(
                      "x-amz-server-side-encryption-customer-algorithm",
                      "AES256"
                    );
                    formData.append(
                      "x-amz-server-side-encryption-customer-key",
                      enKeys.base64
                    );
                    formData.append(
                      "x-amz-server-side-encryption-customer-key-MD5",
                      enKeys.digest
                    );
                  } else {
                    formData.append("AWSAccessKeyId", ftS3Data.keyId);
                    formData.append("signature", ftS3Data.signature);
                    formData.append("x-amz-server-side-encryption", "AES256");
                  }
                  formData.append("Content-type", file.type);
                  // formData.append("file", file);
                }
                file.prefix = ftS3Data.prefix;
              } else {
                var requestId = uuidv4()
                generateSASAnduploadToTempLocation(file, {
                  appinID: fusDetail.appinID,
                  request_id: requestId,
                  accessToken: fusDetail.accessToken,
                  userId: fusDetail.userId,
                  orgId: fusDetail.orgId,
                }).then((fname) => {
                  var paramsData = {
                    s3DirectUpload: file.s3DirectUpload,
                    s3key: '',
                    prefix: '',
                    fileName: replaceSpcicalCharacter(file.name),
                    fileSize: file.size
                  };
                  paramsData['fus_type'] = 1;
                  paramsData['fus_status'] = 2;
                  paramsData['s3DirectUpload'] = 2;
                  paramsData['prefix'] = "FUS_" +requestId;

                  file.source_fileName = fname
                  file.requestId = requestId
                  let fileSignature = `FUS_${requestId}`
                  let imgLocation =
                    `${wbConfig.baseDomainUrl}` +
                    '/vnext/fus/api/v1/download/' +
                    `${fileSignature}`;

                  let exisDesc = $(eleId).html();
                  if (exisDesc == undefined) {
                    exisDesc = '';
                  }
                  let imgTagVal = `<img class="imgViewerCtrl ftImage" src="${imgLocation}"  />`;
                  if ($(exisDesc).hasClass("ftImageDiv")) {
                    $(eleId)
                      .find(".ftImageDiv")
                      .append(imgTagVal);
                    exisDesc = $(eleId).html();
                  } else {
                    exisDesc = `<div class="ftImageDiv">${exisDesc}${imgTagVal}</div>`;
                  }
                  updateFreeText(exisDesc, null, file)
                })
              }
            })
            myDropzone.on("success", (file:any, response:any) => {
              if (!fusDetail.isFUSEnabled) {
                let imgLocation = $("Location", response).text();
                const imgKey = $("Key", response).text();
                const bucket = $("Bucket", response).text();
                let acl = "public-read";
                const s3FormData:any = {};
                if (bucket.toLowerCase().indexOf("workboard") == -1) {
                  acl = "authenticated-read";
                  s3FormData.imgUrl = imgLocation;
                  s3FormData.imgKey = imgKey;
                }
                s3FormData.authVal = acl;
                $.ajax({
                  url: getS3Url,
                  type: "POST",
                  dataType: "json",
                  data: s3FormData
                }).done(data => {
                  const myObjectS3Data = data;
                  let exisDesc = $(eleId).html();
                  if (exisDesc == undefined) {
                    exisDesc = '';
                  }
                  if (typeof myObjectS3Data.imgUrl !== "undefined") {
                    imgLocation = myObjectS3Data.imgUrl;
                  }
                  const imgTagVal = `<img class="imgViewerCtrl ftImage" src="${imgLocation}"  />`;
                  if ($(exisDesc).hasClass("ftImageDiv")) {
                    $(eleId)
                      .find(".ftImageDiv")
                      .append(imgTagVal);
                    exisDesc = $(eleId).html();
                  } else {
                    exisDesc = `<div class="ftImageDiv">${exisDesc}${imgTagVal}</div>`;
                  }
                  props.updateFreeText(exisDesc, myObjectS3Data, file);
                });
              }
              myDropzone.destroy();
            });
            myDropzone.on("error", (files: any, response: any, xhr:any) => {
              try {
                alert(t("Unable to add image. Please try again later."));
                $.ajax({
                  url: getS3Url,
                  type: "POST",
                  dataType: "json",
                  data: { authVal: "public-read" }
                }).done(data => {
                  const myObjectS3Data = data;
                  props.updateFreeText(null, myObjectS3Data);
                  removeLoaderWidget();
                });
                removeLoaderWidget();
                myDropzone.destroy();
              } catch (err) {}
            });
          }
        });
    };
    return (
        <div className={`wsBoardAddAiWrapper ${wrapperClass}`}>
            <div
            className="wsBoardAddAi"
            ref={freetextAdd}
            id={`freetextAdd_${columnId}`}
            contentEditable="true"
            />
        </div>
    )
}

export default FreeTextForm;